import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Colors from "./colors"
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Logo from "../Assets/Logo.png"

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress style={{'color': Colors.globalColor8}}/>
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0} 
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <img src={Logo} width={30}  alt="logo"/>
      </Box>
    </Box>
  );
}


export default function CircularIndeterminate() {
  return (
    <Grid container justify="center" alignItems="center">
      <Grid item>
        <CircularProgressWithLabel  />
      </Grid>
    </Grid>
  );
}

